import { Outlet, createFileRoute } from "@tanstack/react-router"

import Demand2PortfolioLayout from "~/components/demand-2/portfolio/Demand2PortfolioLayout"
import NotFound from "~/components/reusable/NotFound"
import useShowHelix from "~/hooks/useShowHelix"

export const Route = createFileRoute("/_auth/demand/_layout")({
  component: RouteComponent,
})

// Gates the whole /demand tree — nested collection layouts render inside this Outlet, so
// one check here covers them; each still re-checks independently (see their own guard).
function RouteComponent() {
  const showHelix = useShowHelix()
  if (!showHelix) return <NotFound />

  return (
    <Demand2PortfolioLayout>
      <Outlet />
    </Demand2PortfolioLayout>
  )
}
